module.exports = __webpack_public_path__ + "static/img/Angus_Brayshaw_desktop.d77c90d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Angus_Brayshaw_desktop.jpg
// module id = vJjg
// module chunks = 0